import { Form } from 'antd';
import { messages, placeHolders } from '../../../../../../constants';
import { CustomSelect } from '../../../../../uiComponents/CustomSelect';

export const CabainSelect = ({
  id,
  treatmentTypeId,
  isScheduled,
  onCabainChange,
  getCabainOptions,
}) => {
  return (
    <Form.Item
      label="Cabina"
      name="cabainId"
      rules={[
        {
          required: true,
          message: messages.required('Cabina'),
        },
      ]}
    >
      <CustomSelect
        placeholder={placeHolders.cabain}
        disabled={!isScheduled}
        onChange={onCabainChange}
        options={getCabainOptions(id, treatmentTypeId)}
      />
    </Form.Item>
  );
};
